import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListSectionsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'SectionsCounts',
  props: {
    sectionCounts: null
  },
  emits: ['section-clicked'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var variables = computed(function () {
      return {
        filters: {
          parentIsNull: true,
          linkedToMetrics: true
        }
      };
    });
    var _useListSectionsQuery = useListSectionsQuery(variables),
      result = _useListSectionsQuery.result;
    var selectedSectionIds = ref([]);
    watch(selectedSectionIds, function () {
      emit('section-clicked', selectedSectionIds.value);
    });
    var countsBySectionId = computed(function () {
      var map = new Map();
      var _iterator = _createForOfIteratorHelper(props.sectionCounts || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          if (row.sectionId != null) {
            map.set(String(row.sectionId), row.count || 0);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return map;
    });
    var sectionsTree = computed(function () {
      var _result$value;
      var allSectionsMap = new Map();
      var _processSection = function processSection(section) {
        allSectionsMap.set(section.id, _objectSpread(_objectSpread({}, section), {}, {
          metricCount: countsBySectionId.value.get(String(section.id)) || 0
        }));
        if (section.sections) {
          section.sections.forEach(_processSection);
        }
      };
      var rootSections = ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listSections) || [];
      rootSections.forEach(_processSection);
      var buildTree = function buildTree(root) {
        var _allSectionsMap$get;
        var node = {
          id: root.id,
          label: root.label,
          metricCount: ((_allSectionsMap$get = allSectionsMap.get(root.id)) === null || _allSectionsMap$get === void 0 ? void 0 : _allSectionsMap$get.metricCount) || 0,
          children: (root.sections || []).map(function (s) {
            var _allSectionsMap$get2;
            return {
              id: s.id,
              label: s.label,
              metricCount: ((_allSectionsMap$get2 = allSectionsMap.get(s.id)) === null || _allSectionsMap$get2 === void 0 ? void 0 : _allSectionsMap$get2.metricCount) || 0
            };
          })
        };
        return node;
      };
      var tree = rootSections.map(buildTree);
      var _updateMetricCounts = function updateMetricCounts(node) {
        if (node.children && node.children.length > 0) {
          var sum = 0;
          node.children.forEach(function (child) {
            sum += _updateMetricCounts(child);
          });
          node.metricCount = sum;
        }
        return node.metricCount;
      };
      tree.forEach(_updateMetricCounts);
      var _pruneZeroNodes = function pruneZeroNodes(node) {
        var _node$children;
        var prunedChildren = ((_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.map(_pruneZeroNodes).filter(function (c) {
          return c !== null;
        })) || [];
        var hasCount = (node.metricCount || 0) > 0;
        var hasChildren = prunedChildren.length > 0;
        if (!hasCount && !hasChildren) {
          return null;
        }
        return _objectSpread(_objectSpread({}, node), {}, {
          children: prunedChildren
        });
      };
      return tree.map(_pruneZeroNodes).filter(function (n) {
        return n !== null;
      });
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      variables: variables,
      result: result,
      selectedSectionIds: selectedSectionIds,
      countsBySectionId: countsBySectionId,
      sectionsTree: sectionsTree
    };
  }
});